import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "../../../Helpers/auth.provider";
import { persistStore } from 'redux-persist';
import { store } from "../../../index";
import { Spin } from "react-cssfx-loading";

export const PrivateRoute = ({ component, ...rest }) => {

    console.log("private route")
    const renderFn = (Component) => (props) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect, getUser }) => {
                if (!!Component && isAuthenticated()) {
                    // var user = getUser();
                    // user.then((result) => {
                    //     rest.actions.setUserInfo(result.profile);
                    // });

                    return <Component {...props} />;
                } else {

                    persistStore(store).purge();
                    signinRedirect();
                    return <div style={{
                        width:'100%',
                        height: '100%',
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}><Spin width="200px" height="200px" color="#4654FB"></Spin></div>;
                }
            }}
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
};